import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Aura from '@primeuix/themes/aura';
import { setupAxios } from './boot/axios';
import { setupWebSocket } from './boot/websocket';

// Import global styles
import './css/app.scss';
import 'vue-search-select/dist/VueSearchSelect.css';

// Create Vue app
const app = createApp(App);

// Setup Pinia store
const pinia = createPinia();
app.use(pinia);

// Setup router
app.use(router);

app.use(PrimeVue, {
  ripple: false,
  theme: {
    preset: Aura,
    options: {
      cssLayer: { name: 'primevue', order: 'primevue' },
    },
  },
});
app.use(ToastService);

// Setup axios global properties
setupAxios(app);

// Setup WebSocket
setupWebSocket(app);

// Mount app
app.mount('#app');
